package kz.dentalcrm.app.screens.diagnosis.edit

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_diagnosis_deleted
import dentalcrm.composeapp.generated.resources.snackbar_diagnosis_updated
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.response_model.diagnosis.Diagnosis
import kz.dentalcrm.app.domain.DiagnosisRepository
import kz.dentalcrm.app.screens.diagnosis.edit.mvi.EditDiagnosisViewEvent
import kz.dentalcrm.app.screens.diagnosis.edit.mvi.EditDiagnosisViewSideEffect
import kz.dentalcrm.app.screens.diagnosis.edit.mvi.EditDiagnosisViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class EditDiagnosisViewModel :
    BaseStateViewModel<EditDiagnosisViewEvent, EditDiagnosisViewState, EditDiagnosisViewSideEffect>() {

    private val diagnosisRepository: DiagnosisRepository by inject()

    private val _isLoading = MutableStateFlow(false)
    val loading: StateFlow<Boolean> = _isLoading

    private fun editDiagnosis(diagnosis: Diagnosis, name: String) {
        setState {
            copy(
                screenState = EditDiagnosisViewState.ScreenState.Editing
            )
        }
        launch(Dispatchers.Default) {
            when (val result = diagnosisRepository.editDiagnosis(
                diagnosis = diagnosis.copy(name = name)
            )) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_diagnosis_updated), SnackbarEvent.SnackbarType.Green))
                    setState {
                        copy(
                            screenState = EditDiagnosisViewState.ScreenState.Edited
                        )
                    }
                }

                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditDiagnosisViewState.ScreenState.Error(
                                error = result.message
                                    ?: "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }

                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditDiagnosisViewState.ScreenState.Error(
                                error = "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }
            }
        }
    }

    private fun deleteDiagnosis(diagnosis: Diagnosis) {
        setState {
            copy(
                screenState = EditDiagnosisViewState.ScreenState.Editing
            )
        }
        launch(Dispatchers.Default) {
            when (val result = diagnosisRepository.deleteDiagnosis(
                diagnosis = diagnosis
            )) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_diagnosis_deleted), SnackbarEvent.SnackbarType.Green))
                    setState {
                        copy(
                            screenState = EditDiagnosisViewState.ScreenState.Deleted
                        )
                    }
                }

                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditDiagnosisViewState.ScreenState.Error(
                                error = result.message
                                    ?: "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }

                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = EditDiagnosisViewState.ScreenState.Error(
                                error = "Неизвестная ошибка (Проверьте введенные данные)"
                            )
                        )
                    }
                }
            }
        }
    }

    override fun setInitialState() = EditDiagnosisViewState()

    override fun handleEvents(event: EditDiagnosisViewEvent) {
        when (event) {
            is EditDiagnosisViewEvent.EditDiagnosis -> {
                editDiagnosis(diagnosis = event.diagnosis, name = event.naming)
            }

            is EditDiagnosisViewEvent.DeleteDiagnosis -> {
                deleteDiagnosis(diagnosis = event.diagnosis)
            }

            EditDiagnosisViewEvent.Reset -> {
                setState { copy(screenState = EditDiagnosisViewState.ScreenState.Idle) }
            }
        }
    }

    override fun onCleared() {
        setState { EditDiagnosisViewState() }
        _isLoading.value = false
    }
}